import { palette, radius } from "@kashmere/core";
import { productColors } from "./colors.js";

// #291 — the account-card pattern: panel surface, hairline border, 9px radius,
// an inset top highlight. No 16px corners, no glass; "glass" keeps its name as
// an alias for a mid-border panel so callers did not change.
const variantStyles = {
  default: {
    background: palette.bg.panel,
    border: `1px solid ${palette.border.hairline}`,
    borderRadius: `${radius.card}px`,
    padding: "18px 16px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)",
  },
  dark: {
    background: palette.bg.panel,
    border: `1px solid ${palette.border.mid}`,
    borderRadius: `${radius.card}px`,
    padding: "18px 16px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)",
  },
  glass: {
    background: palette.bg.panel,
    border: `1px solid ${palette.border.mid}`,
    borderRadius: `${radius.card}px`,
    padding: "18px 16px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)",
  },
};

export function KashmereCard({
  variant = "default",
  product,
  children,
  style: extraStyle = {},
  className,
  ...rest
}) {
  const base = variantStyles[variant] || variantStyles.default;

  // A product-tinted panel takes the accent as its border — lit edge, same surface.
  let tintedStyle = { ...base };
  if (variant === "glass" && product) {
    const accent = productColors[product];
    if (accent) tintedStyle = { ...base, border: `1px solid ${accent}` };
  }

  return (
    <div
      data-variant={variant}
      className={className}
      style={{ ...tintedStyle, ...extraStyle }}
      {...rest}
    >
      {children}
    </div>
  );
}
